import { Position } from "@xyflow/react";

export type HandleDirection = "TB" | "LR" | "BT";

export function handlePositions(direction: HandleDirection | undefined): {
  source: Position;
  target: Position;
} {
  if (direction === "LR") {
    return { source: Position.Right, target: Position.Left };
  }
  if (direction === "BT") {
    return { source: Position.Top, target: Position.Bottom };
  }
  return { source: Position.Bottom, target: Position.Top };
}
